import { createReducer, on } from "@ngrx/store";

import { AppState, initialState } from "./state";
import * as AppActions from "./actions";

export const appReducer = createReducer(
  initialState,

  on(
    AppActions.getProgram,
    AppActions.getFeatures,
    AppActions.getProgramIntegrations,
    AppActions.getCoupon,
    AppActions.getEngagementFlowsWithProgramEngagementFlow,
    AppActions.getTiers,
    (state): AppState => ({
      ...state,
      loading: true,
    }),
  ),

  on(
    AppActions.getProgramFailure,
    AppActions.getFeaturesFailure,
    AppActions.getProgramIntegrationsFailure,
    AppActions.getCouponFailure,
    AppActions.getEngagementFlowsWithProgramEngagementFlowFailure,
    AppActions.getTiersFailure,
    (state): AppState => ({
      ...state,
      loading: false,
    }),
  ),

  on(
    AppActions.getProgramSuccess,
    (state, { program }): AppState => ({
      ...state,
      loading: false,
      program,
    }),
  ),

  on(
    AppActions.getProgramIntegrationsSuccess,
    (state, { programIntegrations }): AppState => ({
      ...state,
      loading: false,
      programIntegrations,
    }),
  ),

  on(
    AppActions.getFeaturesSuccess,
    (state, { features }): AppState => ({
      ...state,
      loading: false,
      features,
    }),
  ),

  on(AppActions.getCouponSuccess, (state, { coupon }) => ({
    ...state,
    coupon,
    loading: false,
  })),

  on(AppActions.setSessionId, (state, { sessionId }) => ({ ...state, session: { id: sessionId, dateTime: new Date() } })),

  on(
    AppActions.changeSessionLanguage,
    AppActions.changeSessionLanguageSuccess,
    (state, { language }): AppState => ({ ...state, sessionLanguage: language }),
  ),

  on(AppActions.getEngagementFlowsWithProgramEngagementFlowSuccess, (state, { engagementFlows }) => ({
    ...state,
    engagementFlows: {
      ...state.engagementFlows,
      ...engagementFlows.reduce((acc, engagementFlow) => {
        acc[engagementFlow.name] = engagementFlow;
        return acc;
      }, {}),
    },
    loading: false,
  })),

  on(AppActions.getTiersSuccess, (state, { tiers }) => ({
    ...state,
    tiers,
    loading: false,
  })),

  on(AppActions.getBoostsSuccess, (state, { boosts }): AppState => ({
    ...state,
    boosts,
  })),

  on(AppActions.getBoostsFailure, (state): AppState => ({
    ...state,
    boosts: [],
  })),

  on(AppActions.previewWebConfig, (state, { webConfig }): AppState => ({
    ...state,
    program: {
      ...state.program,
      configurations: {
        ...state.program.configurations,
        web: { ...state.program.configurations.web, ...webConfig },
      },
    },
  })),
);
